/**
 * @copyright (C) 2023, Rsupport. All rights reserved
 *
 * @license
 * This software and/or source code may be used, copied and/or disseminated only
 * with the written permission of Rsupport, or in accordance with the terms
 * and conditions stipulated in the agreement/contract under which the software
 * and/or source code has been supplied by Rsupport or its affiliates.
 * Unauthorized use, copying, or dissemination of this file, via any medium, is
 * strictly prohibited, and will constitute an infringement of copyright.
 **/

import CryptoJS from "crypto-js";

export default class CryptoData {
	constructor(
		public _passkey: number[],
		public _salt: number[],
		public _iv: number[],
		public _iteration: number = 1000
	) {}

	public static newData(passkey?: string, salt?: string, iv?: string) {
		const _passkey = passkey ? passkey : CryptoJS.lib.WordArray.random(150 / 8).toString(CryptoJS.enc.Hex);
		const _salt = salt ? salt : CryptoJS.lib.WordArray.random(128 / 8).toString(CryptoJS.enc.Hex);
		const _iv = iv ? iv : CryptoJS.lib.WordArray.random(128 / 8).toString(CryptoJS.enc.Hex);
		return new CryptoData(
			Buffer.from(_passkey).toJSON().data,
			Buffer.from(_salt).toJSON().data,
			Buffer.from(_iv).toJSON().data
		);
	}

	public get salt() {
		if (this._salt.length <= 0) {
			const salt = CryptoJS.lib.WordArray.random(128 / 8).toString(CryptoJS.enc.Hex);
			this._salt = Buffer.from(salt).toJSON().data;
		}
		return Buffer.from(this._salt).toString("utf8");
	}

	public set salt(value) {
		this._salt = Buffer.from(value).toJSON().data;
	}

	public get iv() {
		if (this._iv.length <= 0) {
			const iv = CryptoJS.lib.WordArray.random(128 / 8).toString(CryptoJS.enc.Hex);
			this._iv = Buffer.from(iv).toJSON().data;
		}
		return Buffer.from(this._iv).toString("utf8");
	}

	public set iv(value) {
		this._iv = Buffer.from(value).toJSON().data;
	}

	public get count() {
		return this._iteration;
	}

	public set count(value: number) {
		this._iteration = value;
	}

	public get passKey() {
		return Buffer.from(this._passkey).toString("utf8");
	}

	public set passKey(value: string) {
		this._passkey = Buffer.from(value).toJSON().data;
	}

	public toString() {
		return CryptoJS.SHA256(JSON.stringify({ p: this.passKey, s: this.salt, i: this.iv })).toString();
	}
}
